import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { ElementInspector } from 'element-prompt-builder';
import { RoutingProvider, useRouting, useTheme, createRoutingStrategy } from '@rad/hooks';
import { addResponseInterceptor } from '@rad/utility/http';
import NotImplementedProvider from '@rad/components/utility/not-implemented-context';
import { ContextAuth } from './hooks/useAuth';
import { onSubdomain, configurePathToURL } from './common/routes';
import { configureCommunityRequests } from './common/community-path';
import { useToast } from './contexts/toast';
import { SavedPropertiesProvider } from './contexts/saved-properties';
import { useAuthHelper, httpErrors, getAvailableRoutes, findMatchingRoute, executeInvalidAccessHandler } from './_common';
const AppContent = (props) => {
    const [stateAuth, setToken, setContext] = useAuthHelper();
    const [, setTheme] = useTheme();
    const [routeCurrent, navigate] = useRouting();
    const toast = useToast();
    React.useEffect(() => {
        const removeInterceptor = addResponseInterceptor((res, handled) => {
            if (res.status === 401)
                props.routingConfig.on401();
            const errorMessage = httpErrors[res.status];
            if (!!errorMessage && !handled)
                toast.error(errorMessage);
            return res;
        });
        return removeInterceptor;
    }, [toast]);
    React.useEffect(() => {
        setTheme('light');
    }, [setTheme]);
    const routingContext = {
        routingConfig: props.routingConfig,
        isAuthenticated: stateAuth.isAuthenticated,
        hasPermission: stateAuth.hasPermission,
        onSubdomain,
        matched: null,
        currentPath: routeCurrent.pieces
    };
    const availableRoutes = getAvailableRoutes(routingContext);
    const matched = findMatchingRoute(availableRoutes, routeCurrent);
    routingContext.matched = matched;
    // Each handler declares its own auth condition in `when`, so the auth state is not gated here.
    React.useEffect(() => {
        if (!matched) {
            executeInvalidAccessHandler(routingContext, navigate);
        }
    }, [matched, onSubdomain, stateAuth.isAuthenticated]);
    return (_jsx(ContextAuth.Provider, { value: { 'state': stateAuth, setToken, setContext }, children: _jsx(SavedPropertiesProvider, { children: _jsxs(NotImplementedProvider, { children: [__DEV__ && _jsx(ElementInspector, {}), matched !== null && matched !== void 0 ? matched : React.createElement(props.routingConfig.on404(routingContext), {})] }) }) }));
};
const routingStrategy = createRoutingStrategy(__ROUTING_MODE__, __ROUTING_BASENAME__);
configurePathToURL(routingStrategy);
configureCommunityRequests();
const AppCommon = (props) => {
    return _jsx(_Fragment, { children: _jsx(RoutingProvider, { strategy: routingStrategy, children: props.wrapper(_jsx(AppContent, { routingConfig: props.routingConfig })) }) });
};
export default AppCommon;
